export default function CoWorkingPage() {
  return (
    <div className="pt-24 text-center text-white">
      <h1 className="text-3xl font-bold">CoWorkingPage</h1>
      <p className="mt-4 text-gray-400">CoWorkingPage</p>
    </div>
  );
}
